import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Chuckle, Drip, Shiver, Bob, OnInk } from "./Characters";
import { Reveal } from "./Reveal";

const FEELINGS = [
  { key: "laughter", name: "Laughter", who: "Chuckle", C: Chuckle, bg: "bg-sun", text: "text-ink", line: "Humour in any form: dark, absurd, awkward or simple joy." },
  { key: "tears", name: "Tears", who: "Drip", C: Drip, bg: "bg-sky", text: "text-ink", line: "Sadness, loss, longing or melancholy. If it makes us ache, it counts." },
  { key: "fears", name: "Fears", who: "Shiver", C: Shiver, bg: "bg-grape", text: "text-white", line: "Dread, horror, or the cold realisation that something is wrong." },
];

const Block = ({ f, i }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const rot = useTransform(scrollYProgress, [0, 1], reduce ? [0, 0] : [-10, 10]);
  const flip = i % 2 === 1;
  return (
    <div ref={ref} data-testid={`feelings-block-${f.key}`} className={`${f.bg} ${f.text} relative overflow-hidden`}>
      <div className={`mx-auto flex max-w-7xl flex-col items-start gap-8 px-5 py-16 sm:px-6 md:items-center md:gap-14 md:py-24 lg:px-10 ${flip ? "md:flex-row-reverse" : "md:flex-row"}`}>
        <motion.div style={{ rotate: rot }} className="shrink-0">
          <OnInk className="h-36 w-36 sm:h-48 sm:w-48 lg:h-64 lg:w-64">
            <Bob delay={i * 0.6} className="w-[66%]"><f.C className="h-auto w-full" /></Bob>
          </OnInk>
        </motion.div>
        <div className={`max-w-3xl ${flip ? "md:text-right" : ""}`}>
          <Reveal>
            <p className="font-body text-base font-semibold opacity-90">0{i + 1} · {f.who} feels</p>
            <h3 className="mt-2 font-head text-6xl leading-none tracking-tight sm:text-7xl lg:text-9xl">{f.name}</h3>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 font-body text-xl leading-snug sm:text-2xl lg:text-3xl">{f.line}</p>
          </Reveal>
        </div>
      </div>
    </div>
  );
};

export const Feelings = () => (
  <section data-testid="feelings-section" aria-labelledby="feelings-title">
    <h2 id="feelings-title" className="sr-only">Three feelings</h2>
    {FEELINGS.map((f, i) => <Block key={f.key} f={f} i={i} />)}
  </section>
);
